import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";

interface RiskReportCardCountProps {
    count: number;
    label?: string;
    marginTop?: number;
}

function RiskReportCardCount({ count, label, marginTop = 2.5 }: RiskReportCardCountProps) {
    const { translateNumber } = useTranslation();

    return (
        <Box sx={{ display: "flex", gap: 1, alignItems: "baseline", marginTop }}>
            <Box sx={(theme) => ({ fontSize: "3rem", fontWeight: theme.typography.fontWeightLight, lineHeight: 1 })}>{translateNumber(count)}</Box>
            {label && <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(20), fontWeight: theme.typography.fontWeightRegular })}>{label}</Box>}
        </Box>
    );
}

export default RiskReportCardCount;
